// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	// TODO: write your page related code here...
	$w("#HeaderTransitionPoint").onViewportLeave(() => {
		$w("#ScrollingHeaderStrip").show();
		$w('#defaultHeaderStrip').hide();
	})
	$w("#HeaderTransitionPoint").onViewportEnter(() => {
    $w('#defaultHeaderStrip').show();
	$w("#ScrollingHeaderStrip").hide();
	})
});

